<template>
    <data-view :tableColumns="tableColumns" :tableData="items" :actionButtons="actionButtons" titleKey="ClientName"
        @sortChanged="event => emit('sortChanged', event)" @loadMore="emit('loadMore')">
        <template #col-entry_date="{ row }"> 
                {{  renderDate(row.entry_date)}}
        </template>

        <template #col-amount="{ row }"> 
                {{  formatCurrency(row.amount,row.currency)}}
        </template>
    </data-view>
</template>

<script setup>
import { ref } from 'vue'
import DataView from '@/views/app/components/DataView'
import { formatCurrency, renderDate} from '@/utils/helpers'
const emit = defineEmits(['sortChanged', 'loadMore'])

const props = defineProps({
    items: { type: Array, default: () => ([]) }
})

const tableColumns = ref([
    { key: 'entry_date', label: 'entry_date', sortable: false },
    { key: 'value_date', label: 'date', sortable: false },
    { key: 'type', label: 'Tipo', sortable: false },
    { key: 'code', label: 'code', sortable: false },
    { key: 'ref', label: 'reference', sortable: false },
    { key: 'amount', label: 'amount', sortable: false }

])

const actionButtons = ref([])

</script>

<style></style>
